
import axios, { Axios, AxiosRequestConfig, AxiosResponse } from 'axios';

import { urlJoin } from '@matchlighter/common_library/lib/strings';
import getMetaTagData from './context-store/getMetaTagData';

interface Constructor<T = {}> {
    new(...args: any[]): T;
}

export function makeExtensible<T>(constructCall: (...args) => T): Constructor<T> {
    const extensible = function (...args) {
        Object.setPrototypeOf(this, constructCall(...args) as any)
    }
    return extensible as any;
}

const token = getMetaTagData()["token"];

export class APIBase extends Axios {
    constructor(config: (AxiosRequestConfig & { subURL?: string }) = {}) {
        super({
            ...axios.defaults,
            baseURL: `${process.env.REACT_APP_API_BASE_URL}/${config.subURL || ''}`,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                // 'X-CSRF-Token': csrfToken,
                // 'Authorization': 'Bearer' + env.session_key
                'Authorization': 'Bearer ' + token
            },
            withCredentials: true,
            ...config,
        })
    }

    get base_url() {
        return this.defaults.baseURL;
    }

    request<T = any, R = AxiosResponse<T, any>, D = any>(config: AxiosRequestConfig<D>): Promise<R> {
        if (config.data instanceof FormData) {
            config.headers ||= {}
            config.headers['Content-Type'] = 'multipart/form-data';
        }
        return super.request(config)
    }

    saveModel(url, data, id = data.id) {
        return API.request({
            method: id ? 'PUT' : 'POST',
            url: urlJoin(url, id || ''),
            data,
        })
    }
}

export function saveApiModel(url, data, id?) {
    return API.saveModel(url, data, id)
}

export const API = new APIBase();
console.log(API)
